import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { User } from '@/api/users';

export function useMentionUsers(comments: { comment: string }[]) {
    const mentionIds = new Set<string>();
    // Match @UUID (without brackets)
    const regex = /@([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})/g;

    comments.forEach(comment => {
        let match;
        while ((match = regex.exec(comment.comment)) !== null) {
            if (match[1]) {
                mentionIds.add(match[1]);
            }
        }
    });

    const ids = Array.from(mentionIds);

    return useQuery({
        queryKey: ['users', 'mentions', ids],
        queryFn: async () => {
            if (ids.length === 0) return {};

            // Construct query manually to match reference:
            // filter[id][_in][0]=...&fields[]=...

            const parts: string[] = [];
            ids.forEach((id, index) => {
                parts.push(`filter[id][_in][${index}]=${id}`);
            });

            ['first_name', 'last_name', 'email', 'id', 'avatar'].forEach(field => {
                parts.push(`fields[]=${field}`);
            });

            const queryString = parts.join('&');
            const response = await api.get<{ data: User[] }>(`/users?${queryString}`);

            const userMap: Record<string, User> = {};
            response.data.forEach(user => {
                userMap[user.id] = user;
            });

            return userMap;
        },
        enabled: ids.length > 0,
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
}
